const Typography = (fontFamily) => ({
  fontFamily,

  body1: {
    fontSize: "16px",
    lineHeight: 1.5,
    letterSpacing: "normal",
  },
});

export default Typography;
